@use '../../style/utils';

$_padding-smaller: var(--joy-core-spacing-4) var(--joy-core-spacing-1);
$_padding-section: var(--joy-core-spacing-0);
$_padding-mobile: var(--joy-core-spacing-4);
$_bg: white;


:host {
  /**
   * @prop --panel-bottom-margin: Overrides the default margin value.
   */
  --panel-bottom-margin: var(--joy-core-spacing-8);

  display: block;
  width: 100%;
  max-width: 100%;
}

:host([no-margin]) {
  --panel-bottom-margin: 0;
}

::slotted([slot="panel-title"]) {
  text-align: left;
  color: var(--joy-color-text-title);
  margin: 0;
  padding: 0;
  flex: 1;
}

::slotted([slot="panel-subtitle"]) {
  @include utils.getFontProperties(primary-300);
  flex-basis: 100%;
  margin: var(--joy-core-spacing-2) 0 0;
  padding: 0;
}

::slotted([slot="panel-body"]) {
  margin: var(--joy-core-spacing-4) 0 0;
}

::slotted([slot="panel-action"]) {
  margin-top: var(--joy-core-spacing-9);

  @media screen and (max-width: 767px) {
    margin-top: var(--joy-core-spacing-8);
  }
}

$panel-large-padding: #{var(--joy-core-spacing-8)};
$panel-medium-padding: #{var(--joy-core-spacing-6)};
$panel-small-padding: #{var(--joy-core-spacing-4)};

@mixin padding() {
  padding: var(--joy-core-spacing-9);

  @media screen and (max-width: 767px) {
    padding: var(--joy-core-spacing-4);
  }
}

.joy-panel {
  display: block;
  box-sizing: border-box;
  padding: $panel-large-padding;
  background-color: white;
  border-radius: var(--joy-core-radius-3);
  position: relative;
  border: 1px solid var(--joy-color-neutral-30);
  font-family: var(--joy-font-family-base);
  margin-bottom: var(--panel-bottom-margin);


  &--large {
    padding: $panel-large-padding;
  }

  &--medium {
    padding: $panel-medium-padding;
  }

  &--small {
    padding: $panel-small-padding;
  }

  @media screen and (max-width: 990px) {
    padding: $panel-medium-padding;
  }

  @media screen and (max-width: 767px) {
    padding: $panel-small-padding;
  }

  &__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;

    &--slotted {
      margin-bottom: var(--joy-core-spacing-4);
    }

    &--small {
      ::slotted([slot="panel-title"]) {
        @include utils.getFontProperties(primary-450);
      }
    }

    &--large {
      ::slotted([slot="panel-title"]) {
        @include utils.getFontProperties(primary-650);
      }
    }
  }

  &__body {
    position: relative;
  }

  &__footer {
    joy-wrapper {
      --wrapper-gap: var(--joy-core-spacing-4);
      margin-bottom: 0;

      @media screen and (max-width: 479px) {
        &::part(flex-parent) {
          flex-direction: column;
          align-items: stretch;
        }
      }
    }
  }

  .joy-panel,
  &__section
  {
    margin-top: var(--joy-core-spacing-9);

    @media screen and (max-width: 767px) {
      margin-top: var(--joy-core-spacing-8);
    }

    &:first-child {
      margin-top: 0;
    }

    .joy-panel__title {
      @include utils.getFontProperties(primary-650);
    }
  }
}
